import styled from 'styled-components';
import Text from 'src/design/styleguide/text/Text';
import { gridUnit } from 'src/design/styleguide/common/measurements';

const AdvisorTableEmptyState = styled(Text).attrs({
  as: 'p',
  fontSize: '4x-small',
  role: 'status',
})`
  margin: 0;
  padding: ${gridUnit * 6}px 0;
  color: var(--bx-color---grey-700);
  font-size: 16px;
  text-align: left;
`;

export default AdvisorTableEmptyState;
